import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { materialsVolumetricPriceQuery } from "#modules/materials/infra/materialsVolumetricPrice.query";
import { updateMaterialsVolumetricPrice } from "#modules/materials/infra/updateMaterialsVolumetricPrice.api";

export const useUpdateMaterialsVolumetricPrice = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateMaterialsVolumetricPrice,
    onSuccess: () => {
      void queryClient.invalidateQueries(materialsVolumetricPriceQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { updateMaterialsVolumetricPrice: mutate, ...rest };
};
